<app-page-body *ngIf="!isVisibleForm">
  <!-- header -->
  <app-page-header
    [showRefreshBtn]="false"
    [title]="title | translate"
    [isForm]="true"
    (onBack)="onClose()"
  >
    <div before-btns>
      <button
        [disabled]="
          model?.apiIpRules == undefined ||
          model?.apiIpRules.length == 0 ||
          model?.apiIpRules[0].rules.length == 0
        "
        type="button"
        class="btn btn-light txt-lg button-shadow tw-mx-1 tw-ml-3 btn-hover-rise"
        mat-ripple
        [matTooltip]="'common.edit' | translate"
        (click)="onUpdate()"
      >
        <i class="mdi mdi-pencil-outline mdi-20px text-navyBlue"></i>
      </button>

      <button
        type="button"
        class="btn btn-hover-rise txt-lg button-shadow tw-ml-1 tw-items-center"
        [themeColor]="'btn'"
        mat-ripple
        (click)="showFormApi()"
      >
        <span class="tw-mx-1">{{
          "pages.ipRules.form.addTitle" | translate
        }}</span>
        <i
          class="mdi mdi-plus-circle-outline mdi-18px tw-mx-1 tw-text-white"
        ></i>
      </button>
    </div>
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <section>
      <fieldset>
        <legend>
          {{ fields + "ipRulesFromWebService" | translate }}
        </legend>
        <div class="row" *ngIf="model?.apiIpRules">
          <div class="tw-w-full" *ngFor="let item of model?.apiIpRules">
            <div class="row tw-justify-center gx-2">
              <div class="row gx-2" *ngFor="let rule of item?.rules">
                <!--endpoint-->
                <div class="md:tw-w-1/3">
                  <list-group-item
                    [label]="fields + 'endpoint' | translate"
                    [value]="rule?.endpoint | checkValue"
                  >
                  </list-group-item>
                </div>

                <!--period-->
                <div class="md:tw-w-1/3">
                  <list-group-item
                    [label]="fields + 'period' | translate"
                    [value]="rule?.period | checkValue"
                  >
                  </list-group-item>
                </div>

                <!--limit-->
                <div class="md:tw-w-1/3">
                  <list-group-item
                    [label]="fields + 'limit' | translate"
                    [value]="rule?.limit | checkValue"
                  >
                  </list-group-item>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          *ngIf="
            model.apiIpRules == undefined ||
            model.apiIpRules.length == 0 ||
            model?.apiIpRules[0].rules.length == 0
          "
          class="tw-text-center tw-text-gray-700 dark:tw-text-gray-200 tw-my-5 tw-text-xl tw-dir-rtl ltr:tw-dir-ltr"
        >
          {{ "common.empty" | translate }}
        </div>
      </fieldset>
    </section>

    <section>
      <fieldset>
        <legend>
          {{ fields + "ipRulesFromTable" | translate }}
        </legend>
        <div class="row">
          <!-- ipRules -->
          <div
            *ngIf="ipRules"
            class="tw-pt-5"
            json-formatter
            [json]="ipRules"
            class="tw-text-left dir-ltr dark:tw-invert-[1]"
          ></div>
          <div
            *ngIf="!ipRules"
            class="tw-text-center tw-text-gray-700 dark:tw-text-gray-200 tw-my-5 tw-text-xl tw-dir-rtl ltr:tw-dir-ltr"
          >
            {{ "common.empty" | translate }}
          </div>
        </div>
      </fieldset>
    </section>
  </div>
</app-page-body>

<!-- form -->
<ng-container *ngIf="isVisibleForm">
  <app-ip-rules-form
    page-form
    [rulesModel]="model"
    [isEdit]="isEdit"
    [apiTokenId]="apiTokenId"
    (closePage)="isVisibleForm = false"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-ip-rules-form>
</ng-container>
